import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    TextField,
    Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Add, Remove } from '@material-ui/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
	dialogActions: {
		justifyContent: 'flex-start'
	},
	grid: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		width: '60%'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				width: '100%',
				maxHeight: '70px'
			}
		}
	},
	incrementBtn: {
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: 6,
		border: '1px solid #D0CFD2',
		height: 56,
		width: 56
	},
	fieldWrapper: {
		'& .MuiTextField-root': { minWidth: '378px' }
	},
	summaryHeader: {
		fontSize: '12px',
		color: '#1A1A35',
		fontWeight: '800',
		opacity: '.75'
	},
	text: {
		color: '#1A1A35',
		fontSize: '14px'
	},
	col1: {
		width: '55%'
	},
	col2: {
		width: '20%'
	},
	col3: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end'
	}
}))

const AddDogsDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const membershipTypes = useSelector((state) => state.specific.households.membershipTypes)
	const facility = useSelector((state) => state.specific.facilities.selected)

	const [entry, setEntry] = useState({
		number: 1
	})

	let { isShown, setIsShown, removeDogs, membership } = props

	const removeDogsFromMembership = (entry) => {
		let obj = {
			facility_id: facility._id,
			additional_dogs: entry.number * -1
		}
		removeDogs(obj, membership._id)
	}

	const isValidMembership = () => {
		if (membership.number_of_pets - entry.number < 1) {
			return false
		}
		return true
	}


	const getSummary = () => {
		
		return (
			<div
				style={{
					width: '285px',
					backgroundColor: '#F9F9F9',
					borderRadius: 6,
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'flex-start',
					alignItems: 'flex-start',
					padding: 16
				}}>
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'flex-start',
						border: `0px 0px 1px 0px solid #F3F3F3`,
						paddingBottom: 16,
						marginBottom: 16
					}}>
					<Typography
						variant="body2"
						style={{
							fontWeight: '800',
							fontSize: 16,
							color: '#1A1A35'
						}}>
						Summary
					</Typography>
				</div>

					<div
						style={{
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start'
						}}>
						<div className={classes.col1}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								Dogs Removed:
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								{entry.number}
							</Typography>
						</div>
						<div className={classes.col3}>
						</div>
					</div>
                    <div
						style={{
							width: '100%',
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start'
						}}>
						<div className={classes.col1}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								Dogs Remaining:
							</Typography>
						</div>
						<div className={classes.col2}>
							<Typography
								variant="body2"
								style={{
									fontSize: 14,
									color: '#1A1A35',
									lineHeight: '24px'
								}}>
								{membership.number_of_pets - entry.number}
							</Typography>
						</div>
						<div className={classes.col3}>
						</div>
					</div>
			</div>
		)
	}

	const onExit = () => {
		setIsShown(false)
		setEntry({
			number: 1,
		})

	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onExit={() => onExit()}
			onClose={() => onExit()}
			PaperProps={{
				style: {
					width: 920,
					maxWidth: 920,
					minHeight: 374,
					maxHeight: 500,
					overflowY: 'scroll'
				}
			}}>
			<DialogTitle
				style={{
					marginBottom: 24
				}}>
				REMOVE DOGS FROM MEMBERSHIP
			</DialogTitle>
			<DialogContent>
				<div
					style={{
						width: '100%'
					}}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<div className={classes.grid}>
							
							<div
								style={{
									width: '100%',
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'space-between',
									alignItems: 'flex-start',
									marginBottom: 16
								}}>
								<TextField
									variant="filled"
									value={entry.number || ''}
									style={{ minWidth: '389px' }}
									InputProps={{
										style: {
											width: '50%',
											minWidth: 389
										}
									}}
									label="Number of Dogs To Remove"
								/>
								<div
									style={{
										display: 'flex',
										alignItems: 'center'
									}}>
									<IconButton
										className={classes.incrementBtn}
										style={{
											marginRight: '7px',
											marginLeft: '7px',
											backgroundColor: entry.number <= 1 ? '#F9F9F9' : ''
										}}
										disabled={entry.number <= 1}
										onClick={() => setEntry({ ...entry, number: entry.number - 1 })}>
										<Remove
											style={{
												size: 16,
												fill: entry.number <= 1 ? '#A2A1A4' : '#4D4C4F'
											}}
										/>
									</IconButton>
									<IconButton
										className={classes.incrementBtn}
										disabled={membership.number_of_pets - entry.number == 1}
										onClick={() => setEntry({ ...entry, number: entry.number + 1 })}
										style={
											membership.number_of_pets - entry.number == 1
												? { backgroundColor: '#F9F9F9' }
												: {}
										}>
										<Add
											style={{
												size: 16,
												fill:
                                                    membership.number_of_pets - entry.number == 1
														? '#A2A1A4'
														: '#4D4C4F'
											}}
										/>
									</IconButton>
								</div>
							</div>

						
						</div>
						<div className={classes.receipt}>{getSummary()}</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button
					variant="contained"
					onClick={() => {
						removeDogsFromMembership(entry)
						setIsShown(false)
					}}
					color="secondary"
					disabled={!isValidMembership()}>
					Confirm
				</Button>
				<Button
					variant="outlined"
					onClick={() => {
						setIsShown(false)
					}}
					color="secondary">
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default AddDogsDialog
